import {Component, OnInit} from '@angular/core';
import {TestArea} from '../test-area';
import {AppComponent} from '../../app.component';
import {User} from '../../model/user';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
})
export class LandingPageComponent implements OnInit {

  user = new User();

  constructor(
    public app: AppComponent,
  ) {
  }

  ngOnInit(): void {
    this.app.getUserData().then(user => {
      this.user = user;
    });
  }

  areas(): TestArea[] {
    if (this.user.hasEmbargoPermissions()) {
      return [TestArea.EMBARGO, TestArea.PREPROD, TestArea.PROD];
    } else if (this.user.hasTestPermissions()) {
      return [TestArea.PREPROD, TestArea.PROD];
    }
    return [];
  }
}
